<template>
  <div class="m-date-and-time-picker">
    <MDatePicker
      v-model="vm.dateSelection"
      data-cy="date-picker"
      :placeholder="$t('Placeholder.Date')"
      :disabled="vm.disabled"
      :is-invalid="validation.length > 0"
      v-tooltip="validation" />
    <MTimePicker v-model="vm.timeSelection" :placeholder="$t('Placeholder.Time')" :disabled="vm.disabled" data-cy="time-picker" />
  </div>
</template>

<script setup lang="ts">
import MDatePicker from "@/BasicComponentLibrary/MDatePicker.vue";
import MTimePicker from "@/BasicComponentLibrary/MTimePicker.vue";
import moment from "moment";
import { watch } from "vue";
import { watchEffect } from "vue";
import { reactive, ref } from "vue";
import { useI18n } from "vue-i18n";

//#region Constants

const TODAY = ref(moment());
const DEFAULT_DATE_V_MODEL_FORMAT = "YYYY-MM-DD";
const DEFAULT_TIME_V_MODEL_FORMAT = "HH:mm";
const DEFAULT_DATE_TIME_V_MODEL_FORMAT = `${DEFAULT_DATE_V_MODEL_FORMAT} ${DEFAULT_TIME_V_MODEL_FORMAT}`;

//#endregion

//#region General
const props = defineProps<{ value: string; validation: Record<string, any> }>();
const emits = defineEmits(["input"]);
const { t: $t } = useI18n();
//#endregion

//#region Viewmodel
type ViewModel = { dateSelection: string | null; timeSelection: string | null; disabled: boolean };
const vm = reactive<ViewModel>({ dateSelection: null, timeSelection: null, disabled: false });
//#endregion

watch(
  () => props.value,
  (nv, ov) => {
    if (nv != ov) {
      const split = nv.split(" ");
      vm.dateSelection = split[0] ?? null;
      vm.timeSelection = split[1] ?? null;
    }
  },
  { immediate: true }
);

watchEffect(() => {
  let formattedValue = "";

  if (vm.dateSelection && vm.timeSelection) {
    formattedValue = moment(`${vm.dateSelection} ${vm.timeSelection}`).format(DEFAULT_DATE_TIME_V_MODEL_FORMAT);
  } else if (vm.dateSelection && !vm.timeSelection) {
    formattedValue = moment(`${vm.dateSelection}`).format(DEFAULT_DATE_V_MODEL_FORMAT);
  } else if (!vm.dateSelection && vm.timeSelection) {
    vm.dateSelection = TODAY.value.format(DEFAULT_DATE_V_MODEL_FORMAT);
    formattedValue = moment(`${vm.dateSelection} ${vm.timeSelection}`).format(DEFAULT_DATE_TIME_V_MODEL_FORMAT);
  }

  emits("input", formattedValue);
});
</script>
